import {TFilterPagination} from 'core/models';
import {PAGES} from 'core/modules/routing/constants';

export const MAIN_ARTICLES_BREADCRUMBS = [
    {name: PAGES.HOME_PAGE.title, url: PAGES.HOME_PAGE.path},
    {name: PAGES.ARTICLES_PAGE.title, url: PAGES.ARTICLES_PAGE.path},
];

export const INITIAL_ARTICLES_FILTER_PAGINATION: TFilterPagination = {pageNumber: 1, pageSize: 9};

export const REGEXP_FOR_FRAGMENT = /\[compilation.*compilation\]|\[singleProduct.*singleProduct\]/gu;

export const REGEXP_FOR_FRAGMENT_ID = /([A-Z]?[0-9])\w+/gu;
